'use client';

import { useWindowSizeIsLessThan } from './useWindowSize';

const useIsTabletOrSmallerSize = () => {
	return useWindowSizeIsLessThan('lg');
};

export default useIsTabletOrSmallerSize;
